import { useMemo } from 'react';
import { StanMultiSelect } from '@/components';
import { TagSelectorProps } from '../../types/audience.types';

export const TagSelector = ({
    mode,
    selectedTags,
    availableTags,
    onTagAdd,
    onTagRemove,
    placeholder = 'Select tags',
    disabled = false,
    label,
}: TagSelectorProps) => {
    const labelText = label ?? (mode === 'include' ? 'Tags' : 'Exclude Tags');

    // Convert Tag[] to Option[] for StanMultiSelect
    // Use page_id for pseudo tags to ensure unique keys
    const options = useMemo(() => {
        return availableTags.map((tag, index) => ({
            id: `${tag.name}-${tag.type}-${tag.data?.page_id || tag.data?.section_id || index}`,
            label: tag.name,
        }));
    }, [availableTags]);

    // Get selected tag names
    const selectedLabels = useMemo(() => {
        return selectedTags.map(tag => tag.name);
    }, [selectedTags]);

    // Handle changes from StanMultiSelect
    const handleChange = (labels: string[]) => {
        const addedLabels = labels.filter(label => !selectedLabels.includes(label));

        addedLabels.forEach(label => {
            const tag = availableTags.find(t => t.name === label);
            if (tag) {
                onTagAdd(tag);
            }
        });

        const removedLabels = selectedLabels.filter(label => !labels.includes(label));
        removedLabels.forEach(label => {
            onTagRemove(label);
        });
    };

    return (
        <div className='flex flex-col gap-2'>
            {labelText && (
                <div className='text-dark text-label-xs-bold'>
                    {typeof labelText === 'string' ? <label>{labelText}</label> : labelText}
                </div>
            )}
            <StanMultiSelect
                id={`tag-selector-${mode}`}
                name={`tag-selector-${mode}`}
                value={selectedLabels}
                options={options}
                onChange={handleChange}
                placeholder={placeholder}
                allowCreate={false}
                showOptions
                disabled={disabled}
            />
        </div>
    );
};
